// @ts-nocheck
import { Icon } from '@iconify/react';
import * as React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import arrowIosBackFill from '@iconify/icons-eva/arrow-ios-back-fill';
// material
import { useTheme, styled } from '@mui/material/styles';
import { Box, Paper, Stack, Card, Button, Collapse, TextField, IconButton, Typography, GridLegacy as Grid,  } from '@mui/material';
import plusFill from '@iconify/icons-eva/plus-fill';
import moreVerticalFill from '@iconify/icons-eva/more-vertical-fill';

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
// import AdapterDateFns from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import LightboxModal from '../../../../../components/LightboxModal';

import { useEffect, useState } from 'react';
import LoadingButton from '@mui/lab/LoadingButton';

// components
import Page from '../../../../../components/Page';
import { fData } from '../../../../../utils/formatNumber';
import { doc400 } from '../../../../userImage';
import useSettings from '../../../../../hooks/useSettings';
import DocPreview, { LoadingPreview } from './DocPreview';
import DocUploadDropzone from './DocUploadDropzone';
import { FDate } from 'src/constants/defaultValues';

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  display: 'flex',
  minHeight: '100%',
  alignItems: 'center',
  padding: theme.spacing(12, 0)
}));



// ----------------------------------------------------------------------
// console.log('lib: ',pdfJS);
export default function VerifyCode({doc, toast, isMobile, editable, handleUpdateDoc, handleAddDoc, loading}) {
  const theme = useTheme();
  const canRef = React.useRef();
  const isLight = theme.palette.mode === 'light';
  var cardRef = React.useRef();
  let [name, setName] = useState('');
  let [dob, setDob] = useState('');

  let [rtoNumber, setRtoNumber] = useState('');
  let [issueDate, setIssueDate] = useState('');
  let [cardNmber, setCardNumber] = useState('');
  let   [currentFile, setCurrentFile] = useState(null);
  let   [fileOpen, setFileOpen] = useState(false);
  let [cards, setCards] = useState([]);
  let [file, setFile] = useState(null);
  let [fileId, setFileId] = useState(null);


  useEffect(()=>{
    // console.log('got job data: ',jobdata);
    if(doc && doc.id){
        setName(doc.name);
        setDob(doc.dob);
        setIssueDate(doc.issue_date);
        setRtoNumber(doc.rto_number);
        setCardNumber(doc.card_number);
    }

  },[doc]);

  const handleSubmit = e=>{

    // if(name && rtoNumber && issueDate && cardNmber){
        // let {id, userId, docType} = doc;
		// console.log('issue date: ',issueDate);
		// if(issueDate=='Invalid Date'){
		// 	toast('warning', 'Please select a valid issue date');
		// 	return;
		// }
        let newCard = {
//             name,
// //             dob: new Date(dob).toISOString().split('T')[0],
//             rto_number: rtoNumber,
//             issue_date: new Date(issueDate).toISOString().split('T')[0],
//             card_number: cardNmber,
            // id, userId, docType
        }
		console.log('new card: ',newCard);
		// return;
        if(fileId){
          newCard.fileId = fileId;
        }

        // setDob('');
        // setName('');
        // setCardNumber('');
        // setRtoNumber('');
        // setIssueDate('');

        if(!newCard.fileId && !(doc && doc.id)){
          toast('warning',"Please upload the copy of the card!");
          return;
        }

        if(doc && doc.id){
          handleUpdateDoc(newCard);
        }else{
          handleAddDoc(newCard);
        }
    // }else{
    //     toast('warning', 'please fill all the fields!');
    // }


  }

  const handleViewDoc = doc=>{
    setCurrentFile(doc.file);
    setFileOpen(true);
  }

  // console.log('window object: ',window);
  const stackStyle = {};
  if(isMobile){
    stackStyle.maxHeight = '90vh';
    stackStyle.overflowY = 'auto';
  }

  return (
      <div style={stackStyle} >
            {/* <Typography variant="h4" sx={{ mb: 3 }}>
             Add your white/blue card
            </Typography>
            {
              cards.length>0?(
                <Typography sx={{ color: 'text.secondary', mb: 4 }}>
                  {cards.length} card added
                </Typography>
              ):null
            } */}

      <Stack spacing={2} direction={{ xs: 'column', md: 'row' }}>
          <Paper
            sx={{
              p: 2,
              width: 1,
              position: 'relative',
			  color:isLight?'black': 'white',
			  background:theme.palette.background.paper
            }}
          >

        <Grid container spacing={3} >
          <Grid item xs={5} >
            <Box
                component="img"
                alt="icon"
                src={`/static/icons/QLD-logo-${isLight?'light':'dark'}.png`}
                loading="lazy"
                decoding="async"
            />
          </Grid>

          <Grid item xs={7} >
             <Typography >Blue Card</Typography>
          </Grid>
        </Grid>


        {
          editable?(
            <Box sx={{ mt: 1 }}>
              <DocUploadDropzone
                label="Upload White/Blue Card"
                file={file || doc?.file}
                toast={toast}
                onUploaded={(res)=>{ setFileId(res.fileId); setFile(res.url); }}
              />
            </Box>
          ):null
        }



          </Paper>



      </Stack>
        {/* {
            editable?(
              <LoadingButton fullWidth variant="contained" loading={loading} disabled={!file && !doc?.file} sx={{mt:2}} onClick={handleSubmit}> {doc?.id ? 'Save changes' : 'Upload'} </LoadingButton>
            ):
            doc.file?(
              <Box sx={{my:1}}>
                <img loading="lazy" style={{borderRadius: '5px'}} src={doc400(doc.file)} />
              </Box>

            ):(
              <Typography sx={{ml:1}}>Copy not provided </Typography>
            )
        } */}
        {
            editable?(
              <LoadingButton fullWidth variant="contained" loading={loading} disabled={!file && !doc?.file} sx={{mt:2}} onClick={handleSubmit}> {doc?.id ? 'Save changes' : 'Upload'} </LoadingButton>
            ): <DocPreview file={doc.file} />
        }

    </div>
  );
}